import {
  hooks as metaMaskHooks,
  metaMask,
  store as metaMaskStore
} from './metaMask'
import {
  hooks as walletConnectHooks,
  store as walletConnectStore,
  walletConnect
} from './walletConnect'
import {
  hooks as walletLinkHooks,
  store as walletLinkStore,
  walletLink
} from './walletLink'

export const connectors = [
  [metaMask, metaMaskHooks, metaMaskStore],
  [walletConnect, walletConnectHooks, walletConnectStore]
  // TODO: enable once the WalletLink bug fix lands on @web3-react/walletconnect (https://github.com/NoahZinsmeister/web3-react/issues/400, https://github.com/coinbase/coinbase-wallet-sdk/issues/149)
  // [walletLink, walletLinkHooks, walletLinkStore]
]
